import React from "react";
import Loading from "../components/Loading";
import moment from "moment";
import NoData from "../components/NoData";

const Withdrawal = ({ userpayment, loading, username, currentPage = 1, totalPages = 1, onPageChange }) => {
  return (
    <div className="col-span-12 mt-6">
      <div className="card bg-white shadow-lg">
        <div className="card-body p-6">
          <h4 className="card-title text-xl font-semibold mb-4">
            Withdrawal Transaction History
          </h4>
          {loading ? (
            <Loading />
          ) : !userpayment || userpayment.length === 0 ? (
            <NoData message="No withdrawal transaction history found." />
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full border-collapse border border-gray-300">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 p-2 text-left">#</th>
                    <th className="border border-gray-300 p-2 text-left">Member Name</th>
                    <th className="border border-gray-300 p-2 text-left">Wallet Balance</th>
                    <th className="border border-gray-300 p-2 text-left">Date</th>
                    <th className="border border-gray-300 p-2 text-left">Payment Request</th>
                    <th className="border border-gray-300 p-2 text-left">UPI ID</th>
                  </tr>
                </thead>
                <tbody>
                  {userpayment.map((user, index) => (
                    <tr key={user._id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="border border-gray-300 p-2">{index + 1}</td>
                      <td className="border border-gray-300 p-2 capitalize">{username}</td>
                      <td className="border border-gray-300 p-2">{user?.amount}</td>
                      <td className="border border-gray-300 p-2">
                        {moment(user.created_at).format('DD MMM YYYY hh:mm A')}
                      </td>
                  
                      <td className="border border-gray-300 p-2 text-red-500">
                        {user?.payment_Wid_status === "inactive"
                          ? "Pending"
                          : user?.payment_Wid_status || "-"}
                      </td>
                      <td className="border border-gray-300 p-2">{user?.upi_id}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {totalPages > 1 && (
                <div className="mt-4 flex items-center justify-between gap-3">
                  <button
                    type="button"
                    onClick={() => onPageChange && onPageChange(Math.max(currentPage - 1, 1))}
                    disabled={loading || currentPage === 1}
                    className="rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Previous
                  </button>

                  <span className="text-sm font-medium text-gray-700">
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    type="button"
                    onClick={() => onPageChange && onPageChange(Math.min(currentPage + 1, totalPages))}
                    disabled={loading || currentPage === totalPages}
                    className="rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Withdrawal;
